/**
 * Betting center view types.
 *
 * @readonly
 * @enum {string}
 * @public
 * @memberof Mojito.Modules.BettingCenter
 */
export default {
    BETSLIP: 'betslip',
    OPEN_BETS: 'openBets',
};
